import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLspOnboarding } from "./lspSlice";

function validEmail(email) {
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    email || "",
  );
  return isValidEmail;
}
function validPhone(x) {
  const out = /^[0-9]+$/.test(x || "");
  return out;
}

const useLspGenInfo = () => {
  const dispatch = useDispatch();

  const { activeIndex, generaldata } = useSelector(
    (state) => state.lsponboarding,
  );

  useEffect(() => {
    dispatch(
      setLspOnboarding({
        key: "isEdit",
        value: true,
      }),
    );
    dispatch(
      setLspOnboarding({
        key: "generaldata",
        value: {
          trading_name: "",
          start_date: null,
          end_date: null,
          phone: "",
          phone_code: "",
          email: "",
          hsp_manager_name: "",
          hsp_manager_email: "",
          account_manager_name: "",
          account_manager_email: "",
          account_manager_phone_code: "",
          account_manager_phone: "",
        },
      }),
    );
  }, []);

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, generaldata]);

  useEffect(() => {
    if (
      generaldata?.trading_name ||
      generaldata?.start_date ||
      generaldata?.phone ||
      generaldata?.phone_code ||
      generaldata?.email ||
      generaldata?.hsp_manager_name ||
      generaldata?.hsp_manager_email ||
      generaldata?.account_manager_name ||
      generaldata?.account_manager_email ||
      generaldata?.account_manager_phone_code ||
      generaldata?.account_manager_phone
    ) {
      dispatch(
        setLspOnboarding({
          key: "isLeaveModal",
          value: true,
        }),
      );
    }
  }, [generaldata]);

  const handleEnableNext = () => {
    if (activeIndex === 0) {
      if (
        generaldata?.trading_name &&
        generaldata?.start_date &&
        generaldata?.phone &&
        generaldata?.phone_code &&
        validPhone(generaldata?.phone) &&
        validPhone(generaldata?.phone_code) &&
        generaldata?.email &&
        validEmail(generaldata?.email) &&
        generaldata?.hsp_manager_name &&
        generaldata?.hsp_manager_email &&
        validEmail(generaldata?.hsp_manager_email) &&
        generaldata?.account_manager_name &&
        generaldata?.account_manager_email &&
        validEmail(generaldata?.account_manager_email) &&
        generaldata?.account_manager_phone_code &&
        generaldata?.account_manager_phone &&
        validPhone(generaldata?.account_manager_phone_code) &&
        validPhone(generaldata?.account_manager_phone)
      ) {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };
  const onChangeGeneralInfo = (name, value) => {
    dispatch(
      setLspOnboarding({
        key: "generaldata",
        value: { ...generaldata, [name]: value },
      }),
    );
  };

  return {
    onChangeGeneralInfo,
    generaldata,
  };
};

export default useLspGenInfo;
